import React from 'react';
import { Link } from 'react-router-dom';
import { company, services, projects, whyUs } from '../data/companyData';
import './HomePage.css';

export default function HomePage() {
  const featured = projects.filter(p => p.featured);

  return (
    <main className="homepage">

      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero__bg-lines" aria-hidden="true">
          {[...Array(6)].map((_, i) => <div key={i} className="hero__bg-line" />)}
        </div>
        <div className="container hero__inner">
          <div className="hero__content fade-up">
            <span className="tag">Est. {company.established} · {company.address}</span>
            <h1 className="hero__title">
              Exceptional<br />
              <span className="hero__title-accent">Operations &</span><br />
              Maintenance
            </h1>
            <p className="hero__subtitle">
              Integrated facility management solutions for commercial, residential,
              healthcare, hospitality, and educational assets across New Zealand.
            </p>
            <div className="hero__actions">
              <Link to="/contact" className="btn btn-gold">Get a Quote</Link>
              <Link to="/services" className="btn btn-white-outline">Our Services</Link>
            </div>
          </div>
          {/* Hero visual removed as requested */}
        </div>

        {/* Stats bar removed as requested */}
      </section>

      {/* ── ABOUT STRIP ── */}
      <section className="section section--cream about-strip">
        <div className="container about-strip__inner">
          <div className="about-strip__text">
            <span className="tag">About PrimeFix</span>
            <h2 className="section-title">
              Reliable Solutions.<br />Exceptional Service.
            </h2>
            <div className="divider" />
            <p className="section-subtitle">
              {company.description}
            </p>
            <Link to="/about" className="btn btn-primary about-strip__btn">
              Learn More About Us
            </Link>
          </div>
          <div className="about-strip__features">
            {whyUs.slice(0, 4).map(w => (
              <div key={w.title} className="about-strip__feature">
                <div className="about-strip__feature-dot" />
                <div>
                  <h4 className="about-strip__feature-title">{w.title}</h4>
                  <p className="about-strip__feature-text">{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section className="section services-section">
        <div className="container">
          <div className="services-section__header">
            <div>
              <span className="tag">What We Do</span>
              <h2 className="section-title">Comprehensive<br />Maintenance Services</h2>
            </div>
            <Link to="/services" className="btn btn-outline">All Services →</Link>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <Link
                to={`/services?service=${s.id}`}
                key={s.id}
                className="service-card"
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div className="service-card__icon">{s.icon}</div>
                <h3 className="service-card__title">{s.title}</h3>
                <p className="service-card__desc">{s.description}</p>
                <ul className="service-card__list">
                  {s.items.slice(0, 3).map(item => (
                    <li key={item}><span className="service-card__bullet" />{item}</li>
                  ))}
                </ul>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROJECTS ── */}
      <section className="section section--pearl projects-section">
        <div className="container">
          <div className="projects-section__header">
            <div>
              <span className="tag">Our Portfolio</span>
              <h2 className="section-title">Featured Projects</h2>
            </div>
            <Link to="/projects" className="btn btn-outline">View All →</Link>
          </div>
          <div className="projects-grid">
            {featured.map((p, i) => (
              <div
                key={p.id}
                className={`project-card ${i === 0 ? 'project-card--featured' : ''}`}
              >
                <div className="project-card__header">
                  <span className={`project-card__badge project-card__badge--${p.status}`}>
                    {p.status === 'active' ? 'Active' : 'Completed'}
                  </span>
                  <span className="project-card__category">{p.category}</span>
                </div>
                <h3 className="project-card__title">{p.title}</h3>
                <p className="project-card__client">{p.client}</p>
                <p className="project-card__type">{p.type}</p>
                <div className="project-card__meta">
                  <span>{p.duration} Contract</span>
                  <span>{p.start} – {p.end}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="cta-banner">
        <div className="container cta-banner__inner">
          <div>
            <span className="tag" style={{ color: 'var(--gold-light)' }}>Get Started</span>
            <h2 className="cta-banner__title">
              Ready to partner<br />with PrimeFix?
            </h2>
          </div>
          <div className="cta-banner__actions">
            <Link to="/contact" className="btn btn-gold">Get a Quote</Link>
            <Link to="/services" className="btn btn-outline" style={{ borderColor: 'rgba(255,255,255,0.3)', color: '#fff' }}>
              Explore Services
            </Link>
          </div>
        </div>
      </section>

    </main>
  );
}
